<template>
    <v-footer fixed dark padless app class="no-print">
        <v-row justify="center" no-gutters>
            <v-col cols="12" class="text-caption pa-0 dark font-weight-light" style="text-align: center">
                    Powered by <a :href="mainWebsiteURL" target="_blank" class="white--text"><strong>Cryptium ID</strong></a>
            </v-col>
        </v-row>
    </v-footer>
</template>
<style>
@media print {
    .no-print {
        display: none !important;
    }
}
</style>
<script>
export default {
    computed: {
        mainWebsiteURL() {
            return process.env.VUE_APP_MAIN_WEBSITE_URL ?? 'https://cryptium.com/id/';
        },
    },
};
</script>
